import { TranslateService } from '@ngx-translate/core';
import { Pipe, PipeTransform, inject } from '@angular/core';

@Pipe({ name: 'toStatusBadge' })
export class StatusBadgePipe implements PipeTransform {
  private translate = inject(TranslateService);

  transform(value: string): string {
    if (!value) {
      return '';
    }
    const text = this.translate.instant(value);
    return (
      `<div class="badge rounded-pill text-bg-light" translate><div class="dot ${value.toLowerCase()}"></div>${text}</div>`
    );
  }
}
